import {
  getDetails,
  remove,
  setShowLoader,
  setHideLoader,
  set,
  getList
} from 'src/core/redux/actions';
import { User, UserType } from 'src/core/models';
import LocalStorageService from 'src/core/services/LocalStoregeService';
import { state as stateConstants } from 'src/constants';

export const fetchAccessAndUserData = () => async (dispatch) => {
  await dispatch(setShowLoader());

  const userType = await dispatch(getDetails(UserType)({}));

  if (userType?.data && userType.data?.isAnonymous) {
    await dispatch(setHideLoader());

    return;
  }

  const res = await dispatch(getList(User)());

  if (res.status === 200) {
    await dispatch(set(
      User.NAME,
      stateConstants.IDENTIFIER_TYPE_DETAILS,
      {
        data: { ...res?.consumers?.[0]?.user },
      }
    ));
  }

  await dispatch(setHideLoader());
};

export const resetUserDetails = () => (dispatch) => {
  dispatch(remove(UserType.NAME, 'details'));
  dispatch(remove(User.NAME, 'details'));

  LocalStorageService.removeItem('loggedUser');
};
